module.exports = __webpack_public_path__ + "static/circular-8ce6852bbc4c90688e728aca2e8ccdd7.jpg";